import styled from 'styled-components';

import SegmentedControl from 'components/shared/SegmentedControl';
import {
  useInboundReferralsInsightsActions,
  useInboundReferralsInsightsStore,
} from 'stores/inboundReferralsInsightsStore';
import { Label } from 'styles/typography';

import InboundReferralHighlightsCard from './highlights/InboundReferralHighlightsCard';
import useInboundReferralAnalytics from './query/useInboundReferralAnalytics';
import InboundReferralInsightsSlideout from './slideout/InboundReferralInsightsSlideout';
import InboundReferralDetailsSection from './table/InboundReferralDetailsSection';
import {
  getInboundDetailsParams,
  INBOUND_VIEW_BY,
  INBOUND_VIEW_BY_DIMENSION_MAP,
  INBOUND_VIEW_BY_ENTITY_HEADER,
  InboundViewByValue,
  withInboundDimensionIds,
} from './constants';

const VIEW_BY_OPTIONS = Object.values(INBOUND_VIEW_BY).map((value) => ({
  label: INBOUND_VIEW_BY_ENTITY_HEADER[value],
  value,
}));

export default function InboundReferralsDashboard() {
  const viewBy = useInboundReferralsInsightsStore((state) => state.viewBy);
  const { setViewBy } = useInboundReferralsInsightsActions();
  const dimension = INBOUND_VIEW_BY_DIMENSION_MAP[viewBy];

  const { loading, data, rollups } = useInboundReferralAnalytics(
    withInboundDimensionIds(getInboundDetailsParams(dimension))
  );

  return (
    <>
      <DashboardWrapper>
        <ViewByRow>
          <ViewByLabel>View By:</ViewByLabel>
          <SegmentedControl
            options={VIEW_BY_OPTIONS}
            selectedValue={viewBy}
            onChange={(val) => setViewBy(val as InboundViewByValue)}
            mobileFullWidth
          />
        </ViewByRow>
        <InboundReferralHighlightsCard loading={loading} rollups={rollups} />
        <InboundReferralDetailsSection loading={loading} data={data} />
      </DashboardWrapper>
      <InboundReferralInsightsSlideout />
    </>
  );
}

const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin: 0 auto 24px auto;
    max-width: 1280px;
    width: 100%;
  }
`;

const ViewByRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ViewByLabel = styled(Label)`
  color: ${({ theme }) => theme.colors.black75};

  @media (max-width: 800px) {
    display: none;
  }
`;
